<template>
  <v-layout justify-center>
    <vue-snotify></vue-snotify>
    <v-layout align-content-center justify-center>
      <v-card class="mt-5 pa-6" flat>
        <p class="mt-4  grey--text text--darken-1">
          <center>
            Please enter your email address to request a password reset.
          </center>
        </p>
        <v-form>
          <v-text-field
            ref="email"
            v-model.trim="email"
            label="Email"
            outlined
            append-icon="icons8-envelope-3"
            hide-details="auto"
            data-vv-name="email"
            required
            :rules="[rules.required, rules.email]"
          ></v-text-field>
          <p class="mt-4">
            <center>
              <v-btn
                @click="resetPassword()"
                color="primary"
                class=" px-6  white--text"
                >Send reset password link</v-btn
              >
            </center>
          </p>
        </v-form>
      </v-card>
    </v-layout>
  </v-layout>
</template>

<script>
import Vue from "vue";

export default {
  name: "ResetPassword",
  data() {
    return {
      email: "",
      rules: {
        required: (value) => !!value || "This filed is required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail. Pleas try again ";
        },
      },
    };
  },
  computed: {},
  methods: {
    resetPassword: function() {
      this.email = this.email.toLowerCase();
      if (this.$refs.email.validate()) {
        var self = this;
        this.$firebase.auth
          .sendPasswordResetEmail(self.email)
          .then(function() {
            // Email sent.
            //console.log("email sent");
            self.$snotify.success(
              "A link to reset your password has been sent to your email address. Check your inbox."
            );
          })
          .catch(function(error) {
            //console.log("err: " + error);
            self.$snotify.error(error);
          });
      } else {
        self.$snotify.warning(
          "Fill out your email correctly field in order to proceed."
        );
      }
    },
  },
};
</script>
